export default "__VITE_ASSET__O0xHPY_B__"